import { Link } from "react-router-dom";
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="text-8xl font-bold font-heading text-primary-500 mb-4">404</div>
          <h1 className="text-xl font-semibold text-foreground-900 mb-2">页面未找到</h1>
          <p className="text-foreground-600 text-sm mb-8 max-w-md mx-auto">
            您访问的页面可能已被移除、链接无效或地址输入有误。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/category/all"
              className="px-6 py-2.5 text-sm font-medium text-foreground-700 bg-background-100 border border-background-300 rounded-md hover:bg-background-200 transition-colors duration-200 whitespace-nowrap"
            >
              浏览文章
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}